import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

interface BiddingDateProps {
  dateType: string;
  date: string;
}

const BiddingDate = (props: BiddingDateProps) => {
  const { dateType, date } = props;
  moment.locale('pt-br');

  return (
    <div className="row">
      <div className="col-md-12">{`${dateType}: ${moment.parseZone(date).format('L LT')}`}</div>
    </div>
  );
};

export default BiddingDate;
